import * as React from 'react'
import { Notification } from '~/components/subscription/notification'
import { NavigationBar } from '~/components/subscription/navigation-bar'
import { styles } from './styles.css'

type Props = {
  children: React.ReactNode
}

export const SubscriptionMypageLayout: React.FC<Props> = ({ children }) => {
  return (
    <>
      <NavigationBar />
      <article className={styles.screenContainer}>
        <div className={styles.pageContainer}>{children}</div>
        <Notification />
      </article>
    </>
  )
}
